import {INCREASE_ROUND} from '@/common/mutation-types'

export default {
  [INCREASE_ROUND]({commit}: any) {
    commit(INCREASE_ROUND)
  },
}
